/**
 * @generated SignedSource<<76756fe6533691f48b49afe3c376b006>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TriggerResendActivationInput = {
  clientMutationId?: string | null;
  userId: string;
};
export type resendActivationMailButton_TriggerResendActivationMutation$variables = {
  input: TriggerResendActivationInput;
};
export type resendActivationMailButton_TriggerResendActivationMutation$data = {
  readonly Admin: {
    readonly Auth: {
      readonly triggerResendActivation: {
        readonly __typename: "TriggerResendActivationPayload";
      } | null;
    };
  };
};
export type resendActivationMailButton_TriggerResendActivationMutation = {
  response: resendActivationMailButton_TriggerResendActivationMutation$data;
  variables: resendActivationMailButton_TriggerResendActivationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "TriggerResendActivationPayload",
            "kind": "LinkedField",
            "name": "triggerResendActivation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resendActivationMailButton_TriggerResendActivationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resendActivationMailButton_TriggerResendActivationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "029d7bfa800e3af64f26ff588bd44201",
    "id": null,
    "metadata": {},
    "name": "resendActivationMailButton_TriggerResendActivationMutation",
    "operationKind": "mutation",
    "text": "mutation resendActivationMailButton_TriggerResendActivationMutation(\n  $input: TriggerResendActivationInput!\n) {\n  Admin {\n    Auth {\n      triggerResendActivation(input: $input) {\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b22c7627ef04efb765c83934c0a80c7";

export default node;
